module.exports = __webpack_public_path__ + "media/images/common/user-3526a86cca209fa8d05e5b34c8ee7d07.png";